import React from 'react';
import PropTypes from 'prop-types';
import { StyledInput, InputBox, StyleBoxIcon } from './style';
import Icon from '../Icon';
import IconSearch from '../../../../assets/images/svg/Search.svg';

const SearchInput = ({
  onClickSearch,
  onChangeSearch,
  placeholder,
  name,
  className,
  expanded
}) => (
  <InputBox className={className} expanded={expanded}>
    <StyledInput
      type="text"
      name={name}
      onChange={event => onChangeSearch(event.target.value)}
      placeholder={placeholder}
    />
    <StyleBoxIcon
      big
      onClick={onClickSearch}
      id="button-search"
      expanded={expanded}
    >
      <Icon color="light" size="m" svg={IconSearch} />
    </StyleBoxIcon>
  </InputBox>
);

SearchInput.propTypes = {
  className: PropTypes.string,
  onClickSearch: PropTypes.func,
  onChangeSearch: PropTypes.func,
  placeholder: PropTypes.string,
  expanded: PropTypes.bool,
  name: PropTypes.string
};

SearchInput.defaultProps = {
  expanded: false,
  onChangeSearch: () => {},
  onClickSearch: () => {}
};

export default SearchInput;
